import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b36afce"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", [{
            'button--disabled': _ctx.disabled,
        }, _ctx.styleClasses ]]),
    tabindex: _ctx.tabindex,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: _ctx.icon
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
    (_ctx.linkIndicator)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          icon: "icon_link-indicator",
          class: "link-indicator"
        }))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}